import PageFieldsToolBar from './PageFieldsToolBar';

export default PageFieldsToolBar;
